export default __webpack_public_path__ + "12c9bb7bdd13144fbcee929f822d5b44.png";